import React, { FC } from 'react'

import { Skeleton, Typography } from '@mui/material'
import Box from '@mui/material/Box'

import { currencyFormatter } from '../../utils'

import { MoneyValueProps } from './types'

export const MoneyValue: FC<MoneyValueProps> = ({
  currency,
  money,
  bigFont = false,
  isLoading,
}) => {
  const hasMoneyValue = money !== null && money !== undefined && !Number.isNaN(Number(money))
  const roundedAmount = hasMoneyValue ? Number(money).toFixed(2) : null
  const splitInfo = roundedAmount ? roundedAmount.split('.') : []
  const [main, cents] = splitInfo
  const formattedMoneyValue = currencyFormatter(currency, Number(splitInfo[0]), {}, true)

  return main ? (
    <Box>
      <Typography component="span" variant={bigFont ? 'h3' : 'h4'}>
        {isLoading ? <Skeleton /> : formattedMoneyValue}
      </Typography>
      {cents && !isLoading ? (
        <Typography component="span" variant="h6">{`.${cents}`}</Typography>
      ) : null}
    </Box>
  ) : (
    <Typography variant={bigFont ? 'h3' : 'h4'}>{isLoading ? <Skeleton /> : '-'}</Typography>
  )
}
